import { fetchRequestWithTypes } from './index.js';

export const GET_REFERRAL_HOME_REQUEST = 'GET_REFERRAL_HOME_REQUEST';
export const GET_REFERRAL_HOME_SUCCESS = 'GET_REFERRAL_HOME_SUCCESS';
export const GET_REFERRAL_HOME_ERRORED = 'GET_REFERRAL_HOME_ERRORED';

export const getReferralHome = () =>
	fetchRequestWithTypes({
		types: [
			GET_REFERRAL_HOME_REQUEST,
			GET_REFERRAL_HOME_SUCCESS,
			GET_REFERRAL_HOME_ERRORED,
		],
		request: {
			method: 'GET',
			path: `/apis/referrals/api/v2/users/:uuid/views/home`,
		},
	});
